import { useIsBeheerder } from '../contexts/OrgInfoContext';

export function useBeheerder(): boolean {
  return useIsBeheerder();
}
